import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/navigation/Sidebar';
import TopBar from '../components/navigation/TopBar';
const MainLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-white text-slate-800">
      <Sidebar />
      {mobileOpen && (
        <div className="fixed inset-0 z-40 flex lg:hidden">
          <div className="w-64 bg-white">
            <Sidebar />
          </div>
          <div
            aria-hidden="true"
            className="flex-1 bg-black/30 backdrop-blur-sm"
            onClick={() => setMobileOpen(false)}
          />
        </div>
      )}
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar onMenuToggle={() => setMobileOpen((open) => !open)} />
        <main className="flex-1 overflow-y-auto px-4 py-6 sm:px-8 lg:px-12">
          <Outlet />
        </main>
        <footer className="flex items-center justify-center border-t border-slate-100 px-4 py-4 text-xs text-slate-400">
          <div className="flex items-center gap-3">
            <span>Finance Console</span>
            <span className="text-slate-300">·</span>
            <span className="hidden text-slate-400 sm:inline">Live sync enabled</span>
            <span className="rounded-full border border-slate-200 bg-slate-100 px-3 py-1 text-[11px] font-medium text-slate-600">
              Beta
            </span>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default MainLayout;
